import { IProjectResponseDto, IProjectTaskDto, TaskTypeEnum } from 'types';

export const isContainerTaskBlockedFromAssign = (
  task: IProjectTaskDto | undefined | null
): boolean =>
  !!task && task.type === TaskTypeEnum.Container && !task?.container?.num;

export const findTaskBySubtaskId = (
  project: IProjectResponseDto | undefined | null,
  subtaskId: string | undefined | null
): IProjectTaskDto | undefined => {
  if (!project || !subtaskId) return undefined;
  return project.tasks?.find(t =>
    t.subtasks?.some(st => String(st._id) === String(subtaskId))
  );
};

export const isSubtaskBlockedFromAssign = (
  project: IProjectResponseDto | undefined | null,
  subtaskId: string | undefined | null
): boolean =>
  isContainerTaskBlockedFromAssign(findTaskBySubtaskId(project, subtaskId));
